// extracted by mini-css-extract-plugin
var _1 = "FieldVariableCardItem-moduleFieldVariableCardItem__cl1bP";
var _2 = "FieldVariableCardItem-moduledetails__TIwQb";
var _3 = "FieldVariableCardItem-modulelabel___YZwx";
var _4 = "FieldVariableCardItem-modulelabelContainer__D5xl1";
var _5 = "FieldVariableCardItem-modulevariable__m0ZLs";
export { _1 as "FieldVariableCardItem", _2 as "details", _3 as "label", _4 as "labelContainer", _5 as "variable" }
